export default "/apps/maps/img/elevation.png";